import { EMPTY_OBJECT, DEFAULT_PADDING, generateForAllDevice, DEFAULT_CONTENTS } from './const'
import {
  CONTAINER_ADDITIONAL_DOCUMENTS,
  DEFAULT_CONTAINER_DATA,
  DEFAULT_CONTAINER_PARAMS,
} from './container/const'
import { DEFAULT_PLACEHOLDER_DATA, DEFAULT_PLACEHOLDER_PARAMS } from './placeholder/const'

export const predefined = {
  flex: {
    'universal-container': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      children: [],
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
    },
    'flex-3': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: Array(2).fill({
        type: 'placeholder',
        contents: DEFAULT_CONTENTS(),
        params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
          pc: {
            width: {
              value: 50,
              unit: '%',
            },
          },
          tablet: {
            width: {
              value: 50,
              unit: '%',
            },
          },
          mobile: {
            width: {
              value: 50,
              unit: '%',
            },
          },
        }),
        data: DEFAULT_PLACEHOLDER_DATA(),
        children: [],
      }),
    },
    'flex-4': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: [
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          properties: {
            additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
          },
          children: [],
        },
      ],
    },
    'flex-5': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: Array(4).fill({
        type: 'placeholder',
        contents: DEFAULT_CONTENTS(),
        params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
          pc: {
            width: {
              value: 25,
              unit: '%',
            },
          },
          tablet: {
            width: {
              value: 25,
              unit: '%',
            },
          },
          mobile: {
            width: {
              value: 25,
              unit: '%',
            },
          },
        }),
        data: DEFAULT_PLACEHOLDER_DATA(),
        children: [],
      }),
    },
    'flex-6': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: [
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 25,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 25,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 25,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 50,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 25,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 25,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 25,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    'flex-7': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: Array(4).fill({
        type: 'placeholder',
        contents: DEFAULT_CONTENTS(),
        params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
          pc: {
            width: {
              value: 50,
              unit: '%',
            },
          },
          tablet: {
            width: {
              value: 50,
              unit: '%',
            },
          },
          mobile: {
            width: {
              value: 50,
              unit: '%',
            },
          },
        }),
        data: DEFAULT_PLACEHOLDER_DATA(),
        children: [],
      }),
    },
    'flex-8': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: [
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 50,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 50,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 100,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 100,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 100,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    'flex-9': {
      name: 'flex-9',
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      data: DEFAULT_CONTAINER_DATA(),
      contents: DEFAULT_CONTENTS(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: [
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 50,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 50,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'container',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(
            {
              padding: DEFAULT_PADDING(),
              width: {
                value: 50,
                unit: '%',
              },
            },
            DEFAULT_CONTAINER_PARAMS()
          ),
          data: DEFAULT_CONTAINER_DATA(),
          children: [
            {
              type: 'placeholder',
              contents: DEFAULT_CONTENTS(),
              params: DEFAULT_PLACEHOLDER_PARAMS(),
              data: DEFAULT_PLACEHOLDER_DATA(),
            },
            {
              type: 'placeholder',
              contents: DEFAULT_CONTENTS(),
              params: DEFAULT_PLACEHOLDER_PARAMS(),
              data: DEFAULT_PLACEHOLDER_DATA(),
            },
          ],
        },
      ],
    },
    'flex-10': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      contents: DEFAULT_CONTENTS(),
      data: DEFAULT_CONTAINER_DATA(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: Array(6).fill({
        type: 'placeholder',
        contents: DEFAULT_CONTENTS(),
        params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
          pc: {
            width: {
              value: 100 / 3,
              unit: '%',
            },
          },
          tablet: {
            width: {
              value: 100 / 3,
              unit: '%',
            },
          },
          mobile: {
            width: {
              value: 100 / 3,
              unit: '%',
            },
          },
        }),
        data: DEFAULT_PLACEHOLDER_DATA(),
        children: [],
      }),
    },
    'flex-11': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      contents: DEFAULT_CONTENTS(),
      data: DEFAULT_CONTAINER_DATA(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: [
        ...Array(4).fill({
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        }),
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    'flex-12': {
      type: 'container',
      params: DEFAULT_CONTAINER_PARAMS(),
      contents: DEFAULT_CONTENTS(),
      data: DEFAULT_CONTAINER_DATA(),
      properties: {
        additionalDocuments: CONTAINER_ADDITIONAL_DOCUMENTS(),
      },
      children: [
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        ...Array(2).fill({
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: 100 / 3,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        }),
        {
          type: 'placeholder',
          contents: DEFAULT_CONTENTS(),
          params: generateForAllDevice(EMPTY_OBJECT, DEFAULT_PLACEHOLDER_PARAMS(), {
            pc: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            tablet: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
            mobile: {
              width: {
                value: (100 / 3) * 2,
                unit: '%',
              },
            },
          }),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
  },
  grid: [
    {
      name: 'grid-1-2',
      type: 'container',
      params: generateForAllDevice(
        {
          layout: 'grid',
          cols: {
            value: 2,
          },
          rows: {
            value: 1,
          },
        },
        DEFAULT_CONTAINER_PARAMS()
      ),
      data: DEFAULT_CONTAINER_DATA(),
      children: [
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    {
      name: 'grid-2-1',
      type: 'container',
      params: generateForAllDevice(
        {
          layout: 'grid',
          cols: {
            value: 1,
          },
          rows: {
            value: 2,
          },
        },
        DEFAULT_CONTAINER_PARAMS()
      ),
      data: DEFAULT_CONTAINER_DATA(),
      children: [
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    {
      name: 'grid-3-1',
      type: 'container',
      params: generateForAllDevice(
        {
          layout: 'grid',
          cols: {
            value: 3,
          },
          rows: {
            value: 1,
          },
        },
        DEFAULT_CONTAINER_PARAMS()
      ),
      data: DEFAULT_CONTAINER_DATA(),
      children: [
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    {
      name: 'grid-1-3',
      type: 'container',
      params: generateForAllDevice(
        {
          layout: 'grid',
          cols: {
            value: 1,
          },
          rows: {
            value: 3,
          },
        },
        DEFAULT_CONTAINER_PARAMS()
      ),
      data: DEFAULT_CONTAINER_DATA(),
      children: [
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    {
      name: 'grid-2-2',
      type: 'container',
      params: generateForAllDevice(
        {
          layout: 'grid',
          cols: {
            value: 2,
          },
          rows: {
            value: 2,
          },
        },
        DEFAULT_CONTAINER_PARAMS()
      ),
      data: DEFAULT_CONTAINER_DATA(),
      children: [
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
    {
      name: 'grid-3-2',
      type: 'container',
      params: generateForAllDevice(
        {
          layout: 'grid',
          cols: {
            value: 3,
          },
          rows: {
            value: 2,
          },
        },
        DEFAULT_CONTAINER_PARAMS()
      ),
      data: DEFAULT_CONTAINER_DATA(),
      children: [
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
        {
          type: 'placeholder',
          params: DEFAULT_PLACEHOLDER_PARAMS(),
          data: DEFAULT_PLACEHOLDER_DATA(),
          children: [],
        },
      ],
    },
  ],
}
